<template>
  <div
    :class="[
      'input-group',
      size && `input-group-${size}`,
      props.class
    ]"
  >
    <slot />
  </div>
</template>

<script setup>
import { SIZES } from '@shared/constants/bootstrap'

/* eslint-disable vue/require-default-prop */
const props = defineProps({
  class: { type: null, required: false },
  size: {
    type: String,
    required: false,
    validator: (val) => SIZES.includes(val),
  },
})
</script>
